export default __webpack_public_path__ + "static/base-7252d7d12e8c9180f27fd27ade6a0b0a.svg";